module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/chair-icon-a18a407f26407041c027b4a0681d08fd.png";